import { render, staticRenderFns } from "./SelectTable.vue?vue&type=template&id=dcbc31cc&scoped=true&"
import script from "./SelectTable.vue?vue&type=script&lang=js&"
export * from "./SelectTable.vue?vue&type=script&lang=js&"
import style0 from "./SelectTable.vue?vue&type=style&index=0&id=dcbc31cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbc31cc",
  null
  
)

export default component.exports